import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

/**
 * What would stop this visit being sent to MN-CMS, asked before the GP presses Send (KIN-1943).
 *
 * The rules are deliberately not restated here. This runs the same `MncmsMessageValidationService`
 * the send runs, so the warning and the refusal cannot drift — which is the failure the old
 * client-side list was heading for, since it knew about gestation weeks and blood pressure and
 * nothing about the patient's PPSN or the GP's council number.
 *
 * Read-only and unaudited backend-side, so it is safe to let the screen ask as often as it
 * re-renders. `canSend: true` means nothing *known* is in the way, not that the send will
 * succeed — Healthlink can be unreachable and the hospital can still reject — so the send path
 * keeps its own error handling.
 *
 * Answers for a CREATE. A correction has one further requirement, a prior sent message, checked
 * at send time; the correction button only appears once one exists, so that is not a gap here.
 */
export const useMncmsReadiness = (consultationId) => {
  const tenantVal = localStorage.getItem("kinesin-tenant") ?? "";

  return useQuery({
    queryKey: ["mncmsReadiness", tenantVal, consultationId],
    enabled: !!tenantVal && !!consultationId,
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/antenatalconsultation/${consultationId}/mncms-readiness`
      );

      return response.data ?? null;
    },
    meta: { errorMessage: "Error checking whether this visit can be sent" },
  });
};
